import { t } from 'i18next'

import { Locale } from 'app/types/app/language'

/** Get the language name of the locale. */
export const language: Record<Locale, string> = {
    'en-GB': 'English',
    'es-ES': 'Español',
    'fr-FR': 'Français',
}

/** Get an array of locale and its name sorted by name. */
export const languageList = () => {
    const list = [
        {
            locale: Locale.enum['en-GB'],
            name: t('english') ?? '',
        },
        {
            locale: Locale.enum['es-ES'],
            name: t('spanish') ?? '',
        },
        {
            locale: Locale.enum['fr-FR'],
            name: t('french') ?? '',
        },
    ]

    list.sort((previous, current) => previous.name.localeCompare(current.name))

    return list
}
